import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export var BASE_PATH = "https://localhost:51000/v1".replace(/\/+$/, "");
export var Configuration = /*#__PURE__*/function () {
  function Configuration() {
    var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Configuration);
    this.configuration = configuration;
  }
  return _createClass(Configuration, [{
    key: "config",
    set: function set(configuration) {
      this.configuration = configuration;
    }
  }, {
    key: "basePath",
    get: function get() {
      return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
  }, {
    key: "fetchApi",
    get: function get() {
      return this.configuration.fetchApi;
    }
  }, {
    key: "middleware",
    get: function get() {
      return this.configuration.middleware || [];
    }
  }, {
    key: "queryParamsStringify",
    get: function get() {
      return this.configuration.queryParamsStringify || querystring;
    }
  }, {
    key: "username",
    get: function get() {
      return this.configuration.username;
    }
  }, {
    key: "password",
    get: function get() {
      return this.configuration.password;
    }
  }, {
    key: "apiKey",
    get: function get() {
      var apiKey = this.configuration.apiKey;
      if (apiKey) {
        return typeof apiKey === 'function' ? apiKey : function () {
          return apiKey;
        };
      }
      return undefined;
    }
  }, {
    key: "accessToken",
    get: function get() {
      var accessToken = this.configuration.accessToken;
      if (accessToken) {
        return typeof accessToken === 'function' ? accessToken : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", accessToken);
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
      }
      return undefined;
    }
  }, {
    key: "headers",
    get: function get() {
      return this.configuration.headers;
    }
  }, {
    key: "credentials",
    get: function get() {
      return this.configuration.credentials;
    }
  }]);
}();
export var DefaultConfig = new Configuration();

/**
 * This is the base class for all generated API classes.
 */
export var BaseAPI = /*#__PURE__*/function () {
  function BaseAPI() {
    var _this = this;
    var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultConfig;
    _classCallCheck(this, BaseAPI);
    this.configuration = configuration;
    _defineProperty(this, "middleware", void 0);
    _defineProperty(this, "fetchApi", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, init) {
        var fetchParams, _iterator, _step, _middleware, response, _iterator2, _step2, middleware, _iterator3, _step3, _middleware2;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fetchParams = {
                url: url,
                init: init
              };
              _iterator = _createForOfIteratorHelper(_this.middleware);
              _context2.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context2.next = 15;
                break;
              }
              _middleware = _step.value;
              if (!_middleware.pre) {
                _context2.next = 13;
                break;
              }
              _context2.next = 9;
              return _middleware.pre(_objectSpread({
                fetch: _this.fetchApi
              }, fetchParams));
            case 9:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 12;
                break;
              }
              _context2.t0 = fetchParams;
            case 12:
              fetchParams = _context2.t0;
            case 13:
              _context2.next = 4;
              break;
            case 15:
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t1 = _context2["catch"](2);
              _iterator.e(_context2.t1);
            case 20:
              _context2.prev = 20;
              _iterator.f();
              return _context2.finish(20);
            case 23:
              response = undefined;
              _context2.prev = 24;
              _context2.next = 27;
              return (_this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            case 27:
              response = _context2.sent;
              _context2.next = 60;
              break;
            case 30:
              _context2.prev = 30;
              _context2.t2 = _context2["catch"](24);
              _iterator2 = _createForOfIteratorHelper(_this.middleware);
              _context2.prev = 33;
              _iterator2.s();
            case 35:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 46;
                break;
              }
              middleware = _step2.value;
              if (!middleware.onError) {
                _context2.next = 44;
                break;
              }
              _context2.next = 40;
              return middleware.onError({
                fetch: _this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                error: _context2.t2,
                response: response ? response.clone() : undefined
              });
            case 40:
              _context2.t3 = _context2.sent;
              if (_context2.t3) {
                _context2.next = 43;
                break;
              }
              _context2.t3 = response;
            case 43:
              response = _context2.t3;
            case 44:
              _context2.next = 35;
              break;
            case 46:
              _context2.next = 51;
              break;
            case 48:
              _context2.prev = 48;
              _context2.t4 = _context2["catch"](33);
              _iterator2.e(_context2.t4);
            case 51:
              _context2.prev = 51;
              _iterator2.f();
              return _context2.finish(51);
            case 54:
              if (!(response === undefined)) {
                _context2.next = 60;
                break;
              }
              if (!(_context2.t2 instanceof Error)) {
                _context2.next = 59;
                break;
              }
              throw new FetchError(_context2.t2, 'The request failed and the interceptors did not return an alternative response');
            case 59:
              throw _context2.t2;
            case 60:
              _iterator3 = _createForOfIteratorHelper(_this.middleware);
              _context2.prev = 61;
              _iterator3.s();
            case 63:
              if ((_step3 = _iterator3.n()).done) {
                _context2.next = 74;
                break;
              }
              _middleware2 = _step3.value;
              if (!_middleware2.post) {
                _context2.next = 72;
                break;
              }
              _context2.next = 68;
              return _middleware2.post({
                fetch: _this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                response: response.clone()
              });
            case 68:
              _context2.t5 = _context2.sent;
              if (_context2.t5) {
                _context2.next = 71;
                break;
              }
              _context2.t5 = response;
            case 71:
              response = _context2.t5;
            case 72:
              _context2.next = 63;
              break;
            case 74:
              _context2.next = 79;
              break;
            case 76:
              _context2.prev = 76;
              _context2.t6 = _context2["catch"](61);
              _iterator3.e(_context2.t6);
            case 79:
              _context2.prev = 79;
              _iterator3.f();
              return _context2.finish(79);
            case 82:
              return _context2.abrupt("return", response);
            case 83:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 17, 20, 23], [24, 30], [33, 48, 51, 54], [61, 76, 79, 82]]);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    this.middleware = configuration.middleware;
  }
  return _createClass(BaseAPI, [{
    key: "withMiddleware",
    value: function withMiddleware() {
      var _next$middleware;
      var next = this.clone();
      next.middleware = (_next$middleware = next.middleware).concat.apply(_next$middleware, arguments);
      return next;
    }
  }, {
    key: "withPreMiddleware",
    value: function withPreMiddleware() {
      for (var _len = arguments.length, preMiddlewares = new Array(_len), _key = 0; _key < _len; _key++) {
        preMiddlewares[_key] = arguments[_key];
      }
      var middlewares = preMiddlewares.map(function (pre) {
        return {
          pre: pre
        };
      });
      return this.withMiddleware.apply(this, _toConsumableArray(middlewares));
    }
  }, {
    key: "withPostMiddleware",
    value: function withPostMiddleware() {
      for (var _len2 = arguments.length, postMiddlewares = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        postMiddlewares[_key2] = arguments[_key2];
      }
      var middlewares = postMiddlewares.map(function (post) {
        return {
          post: post
        };
      });
      return this.withMiddleware.apply(this, _toConsumableArray(middlewares));
    }

    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
  }, {
    key: "isJsonMime",
    value: function isJsonMime(mime) {
      if (!mime) {
        return false;
      }
      return BaseAPI.jsonRegex.test(mime);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, initOverrides) {
        var _yield$this$createFet, url, init, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.createFetchParams(context, initOverrides);
            case 2:
              _yield$this$createFet = _context3.sent;
              url = _yield$this$createFet.url;
              init = _yield$this$createFet.init;
              _context3.next = 7;
              return this.fetchApi(url, init);
            case 7:
              response = _context3.sent;
              if (!(response && response.status >= 200 && response.status < 300)) {
                _context3.next = 10;
                break;
              }
              return _context3.abrupt("return", response);
            case 10:
              throw new ResponseError(response, 'Response returned an error code');
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function request(_x3, _x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "createFetchParams",
    value: function () {
      var _createFetchParams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context, initOverrides) {
        var url, headers, initOverrideFn, initParams, overriddenInit, body, init;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = this.configuration.basePath + context.path;
              if (context.query !== undefined && Object.keys(context.query).length !== 0) {
                // only add the querystring to the URL if there are query parameters.
                // this is done to avoid urls ending with a "?" character which buggy webservers
                // do not handle correctly sometimes.
                url += '?' + this.configuration.queryParamsStringify(context.query);
              }
              headers = Object.assign({}, this.configuration.headers, context.headers);
              Object.keys(headers).forEach(function (key) {
                return headers[key] === undefined ? delete headers[key] : {};
              });
              initOverrideFn = typeof initOverrides === "function" ? initOverrides : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      return _context4.abrupt("return", initOverrides);
                    case 1:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              initParams = {
                method: context.method,
                headers: headers,
                body: context.body,
                credentials: this.configuration.credentials
              };
              _context5.t0 = _objectSpread;
              _context5.t1 = _objectSpread({}, initParams);
              _context5.next = 10;
              return initOverrideFn({
                init: initParams,
                context: context
              });
            case 10:
              _context5.t2 = _context5.sent;
              overriddenInit = (0, _context5.t0)(_context5.t1, _context5.t2);
              if (isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || isBlob(overriddenInit.body)) {
                body = overriddenInit.body;
              } else if (this.isJsonMime(headers['Content-Type'])) {
                body = JSON.stringify(overriddenInit.body);
              } else {
                body = overriddenInit.body;
              }
              init = _objectSpread(_objectSpread({}, overriddenInit), {}, {
                body: body
              });
              return _context5.abrupt("return", {
                url: url,
                init: init
              });
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createFetchParams(_x5, _x6) {
        return _createFetchParams.apply(this, arguments);
      }
      return createFetchParams;
    }()
  }, {
    key: "clone",
    value:
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    function clone() {
      var constructor = this.constructor;
      var next = new constructor(this.configuration);
      next.middleware = this.middleware.slice();
      return next;
    }
  }]);
}();
_defineProperty(BaseAPI, "jsonRegex", new RegExp('^(:?application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(:?;.*)?$', 'i'));
;
function isBlob(value) {
  return typeof Blob !== 'undefined' && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
export var ResponseError = /*#__PURE__*/function (_Error) {
  function ResponseError(response, msg) {
    var _this2;
    _classCallCheck(this, ResponseError);
    _this2 = _callSuper(this, ResponseError, [msg]);
    _this2.response = response;
    _defineProperty(_this2, "name", "ResponseError");
    return _this2;
  }
  _inherits(ResponseError, _Error);
  return _createClass(ResponseError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var FetchError = /*#__PURE__*/function (_Error2) {
  function FetchError(cause, msg) {
    var _this3;
    _classCallCheck(this, FetchError);
    _this3 = _callSuper(this, FetchError, [msg]);
    _this3.cause = cause;
    _defineProperty(_this3, "name", "FetchError");
    return _this3;
  }
  _inherits(FetchError, _Error2);
  return _createClass(FetchError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var RequiredError = /*#__PURE__*/function (_Error3) {
  function RequiredError(field, msg) {
    var _this4;
    _classCallCheck(this, RequiredError);
    _this4 = _callSuper(this, RequiredError, [msg]);
    _this4.field = field;
    _defineProperty(_this4, "name", "RequiredError");
    return _this4;
  }
  _inherits(RequiredError, _Error3);
  return _createClass(RequiredError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|"
};
export function querystring(params) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.keys(params).map(function (key) {
    return querystringSingleKey(key, params[key], prefix);
  }).filter(function (part) {
    return part.length > 0;
  }).join('&');
}
function querystringSingleKey(key, value) {
  var keyPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var fullKey = keyPrefix + (keyPrefix.length ? "[".concat(key, "]") : key);
  if (value instanceof Array) {
    var multiValue = value.map(function (singleValue) {
      return encodeURIComponent(String(singleValue));
    }).join("&".concat(encodeURIComponent(fullKey), "="));
    return "".concat(encodeURIComponent(fullKey), "=").concat(multiValue);
  }
  if (value instanceof Set) {
    var valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return "".concat(encodeURIComponent(fullKey), "=").concat(encodeURIComponent(value.toISOString()));
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return "".concat(encodeURIComponent(fullKey), "=").concat(encodeURIComponent(String(value)));
}
export function mapValues(data, fn) {
  return Object.keys(data).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, fn(data[key])));
  }, {});
}
export function canConsumeForm(consumes) {
  var _iterator4 = _createForOfIteratorHelper(consumes),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var consume = _step4.value;
      if ('multipart/form-data' === consume.contentType) {
        return true;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return false;
}
export var JSONApiResponse = /*#__PURE__*/function () {
  function JSONApiResponse(raw) {
    var transformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (jsonValue) {
      return jsonValue;
    };
    _classCallCheck(this, JSONApiResponse);
    this.raw = raw;
    this.transformer = transformer;
  }
  return _createClass(JSONApiResponse, [{
    key: "value",
    value: function () {
      var _value = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = this;
              _context6.next = 3;
              return this.raw.json();
            case 3:
              _context6.t1 = _context6.sent;
              return _context6.abrupt("return", _context6.t0.transformer.call(_context6.t0, _context6.t1));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function value() {
        return _value.apply(this, arguments);
      }
      return value;
    }()
  }]);
}();
export var VoidApiResponse = /*#__PURE__*/function () {
  function VoidApiResponse(raw) {
    _classCallCheck(this, VoidApiResponse);
    this.raw = raw;
  }
  return _createClass(VoidApiResponse, [{
    key: "value",
    value: function () {
      var _value2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", undefined);
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function value() {
        return _value2.apply(this, arguments);
      }
      return value;
    }()
  }]);
}();
export var BlobApiResponse = /*#__PURE__*/function () {
  function BlobApiResponse(raw) {
    _classCallCheck(this, BlobApiResponse);
    this.raw = raw;
  }
  return _createClass(BlobApiResponse, [{
    key: "value",
    value: function () {
      var _value3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.raw.blob();
            case 2:
              return _context8.abrupt("return", _context8.sent);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function value() {
        return _value3.apply(this, arguments);
      }
      return value;
    }()
  }]);
}();
export var TextApiResponse = /*#__PURE__*/function () {
  function TextApiResponse(raw) {
    _classCallCheck(this, TextApiResponse);
    this.raw = raw;
  }
  return _createClass(TextApiResponse, [{
    key: "value",
    value: function () {
      var _value4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.raw.text();
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function value() {
        return _value4.apply(this, arguments);
      }
      return value;
    }()
  }]);
}();